import { Dispatch, UnknownAction } from '@reduxjs/toolkit';
import { SetStateAction } from 'react';
import { NavigateFunction } from 'react-router-dom';
import { AdminNotificationService } from '../../app/admin/notifications/service';
import authSlice, { IAuthState } from '../../store/slices/auth.slice';
import { ENotificationType } from '../enums/notifications/ENotificationType';
import { ERole } from '../enums/user/ERole';
import { INotifications } from '../interfaces/notifications/INotifications';
import { IPagination } from '../interfaces/shared/IPagination';
import { IUser } from '../interfaces/user/IUser';
import { handleError } from './handleError';

export const handleNotificationClick = async (
  notification: INotifications,
  userData: IUser,
  navigate: NavigateFunction,
  setPagination: React.Dispatch<SetStateAction<IPagination>>,
  dispatch: Dispatch<UnknownAction>,
  authState: IAuthState,
) => {
  const correctRouteKey = userData?.role === ERole.USER ? 'user' : 'admin';
  if (!notification?.isSeen) {
    await AdminNotificationService.clearNotification(notification?.id)
      .then((response) => {
        if (response) {
          dispatch(
            authSlice.actions.setLoginState({
              ...authState,
              userData: {
                ...authState.userData,
                unreadNotifications:
                  Number(authState?.userData?.unreadNotifications ?? 1) - 1,
              },
            }),
          );
          setPagination((prev) => ({
            ...prev,
            updatedAt: new Date()?.getTime(),
          }));
        }
      })
      .catch(handleError);
  }

  if (
    [
      ENotificationType.VACATION_REQUEST_RESPONSE,
      ENotificationType.NEW_VACATION_REQUEST,
    ]?.includes(notification.notificationType)
  ) {
    navigate(`/${correctRouteKey}/leave-days`);
    return;
  }
  if (
    [ENotificationType.ASSIGNED_TO_NEW_DEPARTMENT]?.includes(
      notification.notificationType,
    )
  ) {
    navigate(`/${correctRouteKey}/departments/${notification?.department?.id}`);
    return;
  }
  if (
    [
      ENotificationType.PROJECT_CANCELED,
      ENotificationType.PROJECT_FINISHED,
      ENotificationType.ASSIGNED_TO_NEW_PROJECT,
      ENotificationType.REMOVED_FROM_PROJECT,
      ENotificationType.NEW_USER_TO_PROJECT,
    ]?.includes(notification.notificationType)
  ) {
    navigate(`/${correctRouteKey}/projects/${notification?.project?.id}`);
    return;
  }
  if (
    [ENotificationType.NEW_EMPLOYEE_TO_COMPANY]?.includes(
      notification.notificationType,
    )
  ) {
    navigate(`/${correctRouteKey}/employees`);
    return;
  }
  if (
    ENotificationType.NOT_FINISHED_ATTENDANCE === notification?.notificationType
  ) {
    navigate(`/${correctRouteKey}/attendance`);
    return;
  }
};
